import AbstractBotaoTabela from './AbstractBotaoTabela';

export default class Colvis extends AbstractBotaoTabela {
    getCallback() {
        return {
            extend: 'colvis',
            align: 'container',
            text: this.getText(),
        };
    }

    getIcone() {
        return 'visibility';
    }

    getLabel() {
        return 'Colunas';
    }
}